import PropTypes from 'prop-types';
import React from 'react';
import Button from '../button';
import withTranslate from '../../hoc/with-translate';
import styles from './follow-user-button.scss';

const FollowUserButton = ({ user, t, onClick, children, ...props }) => {
  const handleClick = e => {
    e.preventDefault();
    onClick(e);
  };
  return (
    <span className={styles.container}>
      <Button onClick={handleClick} isSecondary={user.isSubscribed} {...props}>
        {t(user.isSubscribed ? 'follow-button.unfollow' : 'follow-button.follow')}
      </Button>
      {children}
    </span>
  );
};

FollowUserButton.propTypes = {
  user: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default withTranslate(FollowUserButton);



// WEBPACK FOOTER //
// ./app/components/follow-user-button/follow-user-button.js